import React from 'react';
import Image from 'next/image';

export default function HeroLargeBackgroundImage({ block, position }) {
  const {
    background_image,
    background_overlay_color,
    background_overlay_on,
    heading,
    subheading,
    text_color,
    _metadata
  } = block.hero_large_background_image;
  const bgClass = `bg-[${background_overlay_color}]`;

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="hero-large-background-image"
      className={`relative h-120 w-full justify-center text-center lg:h-150 text-[${text_color}] ${background_overlay_on ? `${bgClass}` : ''}`}
    >
      <div
        className={`absolute top-0 left-0 h-full w-full ${background_overlay_on ? `z-10 opacity-70` : ''}`}
      >
        <Image
          src={background_image.url}
          alt={background_image.title.replace(/\.[^/.]+$/, '')}
          fill={true}
          sizes="100vw"
          fetchPriority="high"
          loading="eager"
          className="absolute top-0 left-0 z-0 object-cover opacity-100 sm:max-h-120 lg:max-h-150"
        />
      </div>
      <div className="flex h-full flex-col justify-center px-5 py-15 sm:px-30 lg:px-65">
        {heading && (
          <h1 className={`h2 sm:h1 relative z-30 pb-5`}>{heading}</h1>
        )}
        {subheading && (
          <p className={`body-r lg:body-l relative z-30 pb-5`}>{subheading}</p>
        )}
      </div>
    </section>
  );
}
